export class CustomerCard {
	cardId: string;
	brand: string;
	last4: string;
	expirationMonth: string;
	expirationYear: string;
}

